import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { colors, fonts, spacing, borderRadius, shadows } from '../../constants';

/**
 * SLATrendChart Component
 * Line chart component for SLA adherence trend
 */
const SLATrendChart = ({ data }) => {
  return (
    <Grid size={{ xs: 12 }} sx={{ width: '100%' }}>
      <Paper sx={{ p: spacing.xs, borderRadius: borderRadius.md, boxShadow: shadows.md, width: '100%' }}>
        <Typography variant="h6" sx={{ fontWeight: fonts.weightBold, mb: spacing.xs, fontSize: fonts.fontSizeMd }}>
          SLA Adherence Trend
        </Typography>
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={colors.borderDefault} />
            <XAxis dataKey="month" stroke={colors.textSecondary} />
            <YAxis stroke={colors.textSecondary} />
            <RechartsTooltip />
            <Legend />
            <Line type="monotone" dataKey="adherence" stroke={colors.success} strokeWidth={2} name="Adherence %" />
            <Line type="monotone" dataKey="breached" stroke={colors.error} strokeWidth={2} name="Breached" />
          </LineChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default SLATrendChart;
